import { CanActivateFn, Router } from '@angular/router';
import { AssessmentService } from '../../services/assessment-service/assessment.service';
import { inject } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { AssessmentState } from '../../models/assessment-wrapper.model';
import { of } from 'rxjs';

export const assessmentCompletedGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const assessmentService: AssessmentService = inject(AssessmentService);
  const wrapperId = assessmentService.getCurrentAssessmentWrapperId();
  if (!wrapperId) {
    return router.createUrlTree(['/initial-information']);
  }
  return assessmentService
    .get(wrapperId)
    .pipe(
      switchMap(model =>
        model.state === AssessmentState.COMPLETED
          ? assessmentService.isAssessmentCompleted(wrapperId).pipe(map(ic => ic.isComplete))
          : of(false)
      )
    );
};
